import http from 'conversations-http/clients/http';
export const getVisitors = ({
  vids
}) => {
  return http.get('messages/v2/visitor/batch', {
    query: {
      vid: vids.toArray()
    }
  });
};